<template>
  <div :style="`color:${textColor}`">
    <p class="text-base leading-normal" v-html="text"></p>
  </div>
</template>
<script>
export default {
  name: 'Description',
  props: {
    text: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      required: true,
    },
  },
};
</script>
